import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift, X } from 'lucide-react';
import { REFER_TARGET } from '@/lib/referral';

/**
 * "What's new": the referral program, CLIENTS (operator, 2026-09-23). The wording is the
 * operator's, word for word. One decision on the screen: see the code, or not now.
 *
 * Unlike the work-changing notices, this one blocks nobody, so every way out marks it seen: the
 * two buttons, the X, and the backdrop (the queue honours `dismissOnBackdrop`). "See my code"
 * marks it seen and then goes where the header's "Refer and earn" goes.
 */
export function ReferralProgramAnnouncement({ onAcknowledge }) {
  const navigate = useNavigate();
  const seen = () => onAcknowledge && onAcknowledge();
  const seeCode = async () => { await seen(); navigate(REFER_TARGET); };
  return (
    <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl bg-ug-raised border border-ug-border shadow-2xl"
         data-testid="whats-new-referral-program">
      <button type="button" onClick={seen} data-testid="whats-new-close" aria-label="Close"
              className="tap-auto absolute top-4 right-4 w-7 h-7 rounded-full flex items-center justify-center text-slate-500 hover:text-zinc-100 hover:bg-white/[0.06]">
        <X className="w-3.5 h-3.5" strokeWidth={2} />
      </button>
      <div className="p-6 pb-5 border-b border-ug-border-subtle">
        <div className="flex items-center gap-2 mb-3">
          <Gift className="w-3.5 h-3.5 text-ug-gold" strokeWidth={2} />
        </div>
        <h2 className="font-heading text-2xl text-zinc-100 pr-8">New: refer a friend, earn up to $150</h2>
      </div>
      <div className="p-6 py-5">
        <p className="text-[14px] text-zinc-100/80 leading-relaxed" data-testid="whats-new-referral-body">
          Give a friend 65% off their first order with your code. You get $100 when they place their second order and $50 more on their third. Reward codes work on highlight films and photo bundles.
        </p>
      </div>
      <div className="p-6 pt-5 border-t border-ug-border-subtle bg-ug-surface/20 flex flex-col sm:flex-row gap-2">
        <button data-testid="whats-new-next" onClick={seeCode}
                className="tap-auto flex-1 py-2.5 rounded-lg bg-gold-leaf text-obsidian font-sans text-[11px] font-semibold uppercase tracking-wider">
          See my code
        </button>
        <button data-testid="whats-new-not-now" onClick={seen}
                className="tap-auto flex-1 py-2.5 rounded-lg border border-ug-border text-zinc-100/80 hover:text-zinc-100 hover:bg-white/[0.04] font-sans text-[11px] font-semibold uppercase tracking-wider">
          Not now
        </button>
      </div>
    </div>
  );
}
ReferralProgramAnnouncement.dismissOnBackdrop = true;

export default ReferralProgramAnnouncement;
